import {
  ProductActions,
  ProductListStore
} from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';

class ProductUtils {
  get products() {
    const { products } = ProductListStore.getState();
    return products;
  }

  get hasProducts() {
    return this.products.length;
  }

  get isLoadingProducts() {
    const { fetching } = ProductListStore.getState();
    return fetching;
  }

  setSlug = () => {
    // Take the slug from the product with the most attributes.
    // Rank products based on criteria (variant count + has price range + has sale_price)
    // Grab the highest ranking product

    const rankProduct = prod => {
      return (
        prod.variant_count + +prod.has_price_range + +!!(prod.sale_price && prod.sale_price.numeric)
      );
    };
    let rank = rankProduct(this.products[0]);
    let index = 0;

    this.products.forEach((prod, newIndex) => {
      const newRank = rankProduct(prod);
      if (newRank > rank) {
        rank = newRank;
        index = newIndex;
      }
    });

    const slug = this.products[index].slug;
    window.setTimeout(() => ProductActions.setProductDetailData({ slug }), 0);
    window.setTimeout(ProductActions.loadProduct, 0);
  };

  setProductWhenReady = () => {
    if (this.hasProducts) {
      this.setSlug();
      ProductListStore.removeListener('change', this.setProductWhenReady);
    }
  };

  loadProduct = () => {
    if (this.hasProducts) {
      return this.setSlug();
    }
    ProductListStore.addListener('change', this.setProductWhenReady);
    if (!this.isLoadingProducts) {
      ProductActions.loadProducts();
    }
  };
}

export default new ProductUtils();
